import { useEffect, useState } from "react";
import api from "@/lib/api";
import { User } from "lucide-react";
import { KRAKEN_OCTOPUS } from "@/components/PublicLayout";
import HoloCard from "@/components/HoloCard";

export default function Roster() {
  const [players, setPlayers] = useState([]);
  useEffect(() => { api.get("/roster").then((r) => setPlayers(r.data)).catch(() => {}); }, []);
  // Always show 12 slots — fill with TBD placeholders when there aren't enough players
  const slots = Array.from({ length: 12 }, (_, i) => players[i] || null);
  return (
    <div data-testid="roster-page" className="py-20 relative overflow-hidden">
      <img src={KRAKEN_OCTOPUS} alt="" aria-hidden="true" className="hidden lg:block absolute -right-32 top-10 w-[420px] opacity-[0.07] pointer-events-none select-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <div className="eyebrow mb-3">2027 Roster</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">The Kraken</h1>
        <p className="text-slate-400 mt-4 max-w-2xl">9U travel team. Roster updates throughout the season.</p>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-10">
          {slots.map((p, i) => p ? (
            <HoloCard key={p.id} className="bg-[var(--kraken-bg-2)] border border-[var(--kraken-border)] rounded-xl" testId={`player-${p.jersey_number}`}>
              <div className="aspect-square bg-gradient-to-b from-[#14213D] to-[#050A15] flex items-center justify-center relative">
                <div className="absolute top-3 right-3 font-display text-5xl text-[#00E5FF] opacity-90 drop-shadow-[0_0_18px_rgba(0,229,255,0.55)]">#{p.jersey_number}</div>
                {p.photo_url ? (
                  <img src={p.photo_url} alt={p.name} className="w-full h-full object-cover" />
                ) : (
                  <User size={80} className="text-slate-700" />
                )}
              </div>
              <div className="p-5">
                <div className="font-display text-xl uppercase">{p.name}</div>
                <div className="text-[#00E5FF] text-xs uppercase tracking-widest mt-1">{p.position}</div>
                <div className="text-slate-400 text-xs mt-2">Bats: {p.bats} · Throws: {p.throws}</div>
                {p.bio && <p className="text-slate-300 text-sm mt-3 leading-relaxed">{p.bio}</p>}
              </div>
            </HoloCard>
          ) : (
            <HoloCard key={`tbd-${i}`} className="bg-[var(--kraken-bg-2)] border border-[var(--kraken-border)] rounded-xl opacity-70" testId={`player-slot-${i + 1}`}>
              <div className="aspect-square bg-gradient-to-b from-[#14213D] to-[#050A15] flex items-center justify-center relative">
                <div className="absolute top-3 right-3 font-display text-5xl text-[#00E5FF] opacity-40">#{i + 1}</div>
                <User size={80} className="text-slate-800" />
              </div>
              <div className="p-5">
                <div className="font-display text-xl uppercase text-slate-500">TBD</div>
                <div className="text-[#00E5FF]/60 text-xs uppercase tracking-widest mt-1">Roster Slot</div>
              </div>
            </HoloCard>
          ))}
        </div>
      </div>
    </div>
  );
}
